// SEO metadata and Schema.org structured data for all key routes.

export const SEO_DEFAULTS = {
  siteName: 'Professya',
  siteUrl: 'https://professya.com',
  description:
    'Os astros falam com você. Mapa natal, tarô, I Ching, numerologia e sinastria revelados especificamente para você.',
  image: 'https://professya.com/og/default.png',
  locale: 'pt_BR',
} as const;

export const SEO_ROUTES: Record<string, { title: string; description: string; canonical: string }> = {
  '/': {
    title: 'Professya, Astrologia Personalizada',
    description: 'Os astros falam com você. Mapa natal, tarô, sinastria, I Ching, numerologia e 20+ análises personalizadas baseadas no seu mapa natal único.',
    canonical: 'https://professya.com/',
  },
  '/pricing': {
    title: 'Planos e Preços, Professya',
    description: 'Comece grátis ou assine o plano Premium por R$24,90/mês. Mapa natal completo, sinastria, tarô e 12 sistemas de leitura personalizados.',
    canonical: 'https://professya.com/pricing',
  },
  '/login': {
    title: 'Entrar, Professya',
    description: 'Acesse sua conta Professya e continue sua jornada de autoconhecimento.',
    canonical: 'https://professya.com/login',
  },
  '/register': {
    title: 'Criar conta, Professya',
    description: 'Crie sua conta grátis e descubra seu mapa natal completo em minutos.',
    canonical: 'https://professya.com/register',
  },
  '/privacidade': {
    title: 'Política de Privacidade, Professya',
    description: 'Como a Professya coleta, usa e protege seus dados pessoais, em conformidade com a LGPD.',
    canonical: 'https://professya.com/privacidade',
  },
  '/termos': {
    title: 'Termos de Uso, Professya',
    description: 'Termos e condições de uso da plataforma Professya.',
    canonical: 'https://professya.com/termos',
  },
};

// ─── Schema.org ────────────────────────────────────────────────────────────────

export const SCHEMA_ORG = {
  organization: {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Professya',
    url: 'https://professya.com',
    logo: 'https://professya.com/logo.svg',
    sameAs: [
      'https://instagram.com/professya',
      'https://tiktok.com/@professya',
    ],
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'contato@professya.com',
      contactType: 'customer service',
      availableLanguage: ['Portuguese', 'Spanish', 'English', 'French'],
    },
  },

  webApplication: {
    '@context': 'https://schema.org',
    '@type': 'WebApplication',
    name: 'Professya',
    url: 'https://professya.com',
    applicationCategory: 'LifestyleApplication',
    operatingSystem: 'Web, iOS, Android',
    description:
      'Plataforma de astrologia personalizada: mapa natal completo, tarô, I Ching, numerologia, sinastria e muito mais, revelados especificamente para você.',
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'BRL',
      description: 'Plano gratuito disponível. Planos Premium a partir de R$24,90/mês.',
    },
    screenshot: 'https://professya.com/og/default.png',
    author: { '@type': 'Organization', name: 'Professya' },
  },

  faqPage: {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'Funciona se eu não souber meu horário de nascimento?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Sim. A hora é opcional. Sem ela, calculamos o mapa com base na data e cidade, você terá Sol, Lua, planetas e a maioria das casas.',
        },
      },
      {
        '@type': 'Question',
        name: 'A leitura é personalizada ou genérica por signo?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Cada leitura é gerada na hora para o seu mapa específico. Não existe texto pronto por signo.',
        },
      },
      {
        '@type': 'Question',
        name: 'Posso cancelar quando quiser?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Sim, sem burocracia. Você cancela pelo app ou pelo site a qualquer momento. Garantia de 7 dias sem perguntas.',
        },
      },
      {
        '@type': 'Question',
        name: 'Aceita Pix e outros pagamentos?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Sim. Aceitamos Pix, cartão de crédito (Visa, Mastercard, Elo, Amex) e boleto bancário.',
        },
      },
      {
        '@type': 'Question',
        name: 'Meus dados estão seguros?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Seus dados ficam armazenados com criptografia e nunca são vendidos a terceiros. Seguimos a LGPD rigorosamente.',
        },
      },
    ],
  },
} as const;
